import type { SavedFilterModel } from '@/shared/generated'
import type { UseQueryOptions } from '@/shared/lib/query-client'

import { useQuery } from '@tanstack/react-query'

import { client } from '@/shared/api/client'

export const useSavedFiltersQuery = <T = SavedFilterModel[]>(
	options?: UseQueryOptions<SavedFilterModel[], Error, T>
) =>
	useQuery<SavedFilterModel[], Error, T>({
		queryKey: ['saved-filters'],
		queryFn: () => client.savedFilters.getSavedFilters(),
		...(options || {}),
	})
